import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "className", "color", "element", "maxLines", "style", "tint", "forwardedRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { forwardRef, PureComponent } from 'react';
import Box from '../box';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { COLORS, TINTS } from '../../constants';
import theme from './theme.css';
/** @type {React.ComponentType<any>} */

var factory = function factory(baseType, type, defaultElement) {
  var Text = /*#__PURE__*/function (_PureComponent) {
    _inherits(Text, _PureComponent);

    var _super = _createSuper(Text);

    function Text() {
      _classCallCheck(this, Text);

      return _super.apply(this, arguments);
    }

    _createClass(Text, [{
      key: "render",
      value: function render() {
        var _cx;

        var _this$props = this.props,
            children = _this$props.children,
            className = _this$props.className,
            color = _this$props.color,
            element = _this$props.element,
            maxLines = _this$props.maxLines,
            style = _this$props.style,
            tint = _this$props.tint,
            forwardedRef = _this$props.forwardedRef,
            others = _objectWithoutProperties(_this$props, _excluded);

        var classNames = cx(theme[baseType], theme[type], theme[color], theme[tint], (_cx = {}, _defineProperty(_cx, theme['overflow-multiline'], maxLines > 1), _defineProperty(_cx, theme['overflow-singleline'], maxLines === 1), _cx), className);

        var styles = _objectSpread(_objectSpread({}, maxLines > 1 && {
          MozLineClamp: maxLines,
          WebkitLineClamp: maxLines
        }), style);

        var Element = element || defaultElement;
        return /*#__PURE__*/React.createElement(Box, _extends({
          className: classNames,
          "data-teamleader-ui": baseType,
          element: Element
        }, others, {
          style: styles,
          ref: forwardedRef
        }), children);
      }
    }]);

    return Text;
  }(PureComponent);

  Text.defaultProps = {
    element: null,
    tint: 'darkest'
  };
  var ForwardedText = /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
      forwardedRef: ref
    }));
  });
  ForwardedText.displayName = 'Text';
  return ForwardedText;
};

export { factory as textFactory };